// Tamanhos padrão disponíveis para todos os formatos (organizados por largura decrescente)
export const AVAILABLE_SIZES = [
    [970, 250],
    [970, 210],
    [970, 90],
    [728, 90],
    [468, 60],
    [336, 280],
    [320, 480],
    [320, 250],
    [320, 100],
    [320, 50],
    [300, 600],
    [300, 250],
    [300, 100],
    [300, 50],
    [160, 600],
    [120, 600],
] as const;

// Tipos para tamanhos
export type AdSize = typeof AVAILABLE_SIZES[number];

export interface SizeOption {
    value: string;
    label: string;
}

export const PROVIDERS = {
    'gpt': 'GPT',
    'adp': 'ADP',
};

export const GPT_FORMATS = {
    'TOP_ANCHOR': 'Top Anchor',
    'BOTTOM_ANCHOR': 'Bottom Anchor',
    'AUTO_ANCHOR': 'Auto Anchor',
    'LEFT_SIDE_RAIL': 'Left Side Rail',
    'RIGHT_SIDE_RAIL': 'Right Side Rail',
    'INTERSTITIAL': 'Interstitial',
    'REWARDED': 'Rewarded',
};

export const ADP_FORMATS = {
    'anchor': 'Anchor',
    'slider': 'Slider',
    'corner': 'Corner',
    'in-article': 'In-Article',
    'in-feed': 'In-Feed',
    'billboard': 'Billboard',
    'in-image': 'In-Image',
};

// Mapeamento de ícones únicos para formatos ADP
export const ADP_FORMAT_ICONS = {
    'anchor': '⚓',
    'slider': '📱',
    'corner': '📐',
    'in-article': '📄',
    'in-feed': '📰',
    'billboard': '🚧',
    'in-image': '🖼️',
    'custom': '🎨',
};

// Mapeamento de ícones únicos para formatos GPT
export const GPT_FORMAT_ICONS = {
    'TOP_ANCHOR': '🔝',
    'BOTTOM_ANCHOR': '🔽',
    'AUTO_ANCHOR': '🎯',
    'LEFT_SIDE_RAIL': '⬅️',
    'RIGHT_SIDE_RAIL': '➡️',
    'INTERSTITIAL': '📺',
    'REWARDED': '🎁',
};

// Função helper para obter ícone do formato ADP
export const getAdpFormatIcon = (formatName: string): string => {
    return ADP_FORMAT_ICONS[formatName as keyof typeof ADP_FORMAT_ICONS] || '📱';
};

// Função helper para obter ícone do formato GPT
export const getGptFormatIcon = (formatName: string): string => {
    return GPT_FORMAT_ICONS[formatName as keyof typeof GPT_FORMAT_ICONS] || '🎯';
};